import { Components, Theme } from '@mui/material/styles'

export const MuiDivider: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    /**
     * `!important` is not defensive here, it is REQUIRED.
     *
     * `index.css` sets `#vera-shadow-root * { border-color: hsl(var(--border)) }`.
     * That selector has ID specificity (0-1-0-0); emotion writes this override
     * as a single class (0-0-1-0), so without `!important` this line is
     * authored, computed and discarded, and the tenant's Studio "Border color"
     * renders as the app's default grey instead. Raising specificity is not an
     * option — nothing short of another ID beats an ID, and `&&` only doubles
     * the class count. See `settings/tokens.ts` for the full write-up.
     *
     * `secondary.main` falls back to `border.subtle`, which is exactly what
     * `--border` resolves to, so an unthemed brand renders byte-identically to
     * before this change (`settings/mui/palette.ts`).
     *
     * ⚠️ CONSEQUENCE, and it is the price of the fix: `!important` also beats a
     * per-call-site `sx={{ borderColor }}`. Two sites author `grey[300]`
     * (`OwnerProvenanceCard`, `ReportMissingDrawer`) and they now follow the
     * tenant token instead. Neither renders `grey[300]` TODAY — the blanket
     * rule was already discarding them for the same reason — so nothing
     * regresses; they simply move from one grey to the brand's own divider
     * colour, which is what a divider on a brand's page should be.
     */
    root: ({ theme }) => ({
      borderColor: `${theme.palette.secondary.main} !important`,
    }),
  },
}
